import React, { useState, useEffect, useRef } from 'react'
import './customTooltips.css'

export interface CustomStep {
  data: {
    content1: React.ReactNode
    content2?: React.ReactNode
    content1Style?: string
    content2Style?: string
    buttonLabel?: string
  }
  target: string
}

interface CustomTooltipProps {
  continuous?: boolean
  step: CustomStep
  primaryProps: React.ButtonHTMLAttributes<HTMLButtonElement>
  tooltipProps?: React.HTMLAttributes<HTMLDivElement>
  spotlightClicks?: boolean
}

export const CustomTooltips = ({
  continuous = false,
  step,
  primaryProps,
  tooltipProps,
  spotlightClicks = false,
}: CustomTooltipProps) => {
  const [disabled, setDisabled] = useState<boolean>(!spotlightClicks)
  const timer = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (disabled) {
      const time = step.data.content2 ? 2500 : 1500
      timer.current = setTimeout(() => {
        setDisabled(false)
      }, time)
    }

    return () => {
      if (timer.current) {
        clearTimeout(timer.current)
      }
    }
  }, [disabled, step.data.content2])

  const handleClick = (
    e:
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | React.MouseEvent<HTMLDivElement>,
  ) => {
    if (disabled) {
      e.stopPropagation()
    } else {
      primaryProps.onClick?.(e as React.MouseEvent<HTMLButtonElement>)
      setDisabled(true)
    }
  }

  return (
    <div {...tooltipProps} className="joyrideTooltip" onClick={handleClick}>
      <p className={step.data.content1Style || 'tooltipText1'}>
        {step.data.content1}
      </p>
      {step.data.content2 && (
        <p className={step.data.content2Style || 'tooltipText2'}>
          {step.data.content2}
        </p>
      )}

      {continuous && (
        <button
          {...primaryProps}
          onClick={handleClick}
          className="nextButton"
          disabled={disabled}
        >
          {step.data.buttonLabel}
        </button>
      )}
    </div>
  )
}
